(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('countdown-announcement')) {
    customElements.define(
      'countdown-announcement',
      class extends HTMLElement {
        connectedCallback() {
          this.initTimer = setTimeout(() => this.init(), 0);
        }
        init() {
          if (this.controller) return;
          this.controller = new AbortController();
          const { signal } = this.controller;
          const timer = this.querySelector('[role="timer"]');
          const end = new Date(this.dataset.endDate).getTime();
          if (timer && Number.isFinite(end)) {
            const update = () => {
              // Same three-day cycle and date anchor as M-CODE-1's holiday announcement.
              const cycle = 3 * 86400000;
              const diff = (((end - Date.now()) % cycle) + cycle) % cycle || cycle;
              const values = [
                Math.floor(diff / 86400000),
                Math.floor((diff % 86400000) / 3600000),
                Math.floor((diff % 3600000) / 60000),
                Math.floor((diff % 60000) / 1000),
              ];
              ['days', 'hours', 'minutes', 'seconds'].forEach((part, i) => {
                timer.querySelector(`[data-time="${part}"]`).textContent = String(values[i]).padStart(2, '0');
              });
            };
            update();
            timer.hidden = false;
            this.interval = setInterval(update, 1000);
          }
          const button = this.querySelector('[data-toggle]');
          const panel = this.querySelector('[data-panel]');
          if (!button || !panel) return;
          const trigger = this.querySelector('[data-trigger]');
          const setOpen = (open) => {
            clearTimeout(this.closeTimer);
            button.setAttribute('aria-expanded', String(open));
            panel.hidden = !open;
          };
          const scheduleClose = () => {
            clearTimeout(this.closeTimer);
            this.closeTimer = setTimeout(() => setOpen(false), 150);
          };
          [trigger, panel].forEach((area) => {
            area.addEventListener(
              'pointerenter',
              (event) => {
                if (event.pointerType === 'mouse') setOpen(true);
              },
              { signal }
            );
            area.addEventListener(
              'pointerleave',
              (event) => {
                if (event.pointerType === 'mouse') scheduleClose();
              },
              { signal }
            );
          });
          button.addEventListener('click', () => setOpen(panel.hidden), { signal });
          this.addEventListener(
            'keydown',
            (event) => {
              if (event.key === 'Escape' && !panel.hidden) {
                setOpen(false);
                button.focus();
              }
            },
            { signal }
          );
          this.addEventListener(
            'focusout',
            (event) => {
              if (!this.contains(event.relatedTarget)) setOpen(false);
            },
            { signal }
          );
          document.addEventListener(
            'pointerdown',
            (event) => {
              if (!this.contains(event.target)) setOpen(false);
            },
            { signal }
          );
        }
        disconnectedCallback() {
          clearTimeout(this.initTimer);
          clearTimeout(this.closeTimer);
          clearInterval(this.interval);
          this.controller?.abort();
          this.controller = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };

      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class HeaderWrapper extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.getElementById('shopify-section-header');

			this.exitTimer = null;
			this.onEnterHandler = this.onEnter.bind(this);
			this.onLeaveHandler = this.onLeave.bind(this);
			this.addEventListener('mouseenter', this.onEnterHandler);
			this.addEventListener('mouseleave', this.onLeaveHandler);
		}

		disconnectedCallback() {
			this.removeEventListener('mouseenter', this.onEnterHandler);
			this.removeEventListener('mouseleave', this.onLeaveHandler);
		}

		onEnter() {
			this.preventClose = true;
			this.header.classList.add('is-active');
			clearTimeout(this.exitTimer);
		}

		onLeave() {
			this.exitTimer = setTimeout(() => {
				this.header.classList.remove('is-active');
			}, 400);
		}

	}
	customElements.define('header-wrapper', HeaderWrapper);

	class StickyHeader extends HeaderWrapper {
		constructor() {
			super();
		}

		connectedCallback() {
			super.connectedCallback();

			this.headerBounds = {};
			this.currentScrollTop = 0;
			this.preventReveal = false;
			this.scrollUpActive = false;

			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => this.preventReveal = true;

			window.addEventListener('scroll', this.onScrollHandler, false);
			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

			this.createObserver();
		}

		disconnectedCallback() {
			super.connectedCallback();

			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect;

				if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
					const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
					const boundingClientRect = entries[0].boundingClientRect;

					this.headerBounds = {
						top: scrollTop + boundingClientRect.top,
						bottom: scrollTop + boundingClientRect.bottom
					};
				}

				if (this.dataset.scrollUp !== undefined) {
					this.scrollUpActive = true;
				}

				observer.disconnect();
			});

			observer.observe(this.header);
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (theme.config.mqlSmall || this.scrollUpActive) {
				if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
					requestAnimationFrame(this.hide.bind(this));
				}
				else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
					if (!this.preventReveal) {
						requestAnimationFrame(this.reveal.bind(this));
					}
					else {
						window.clearTimeout(this.isScrolling);

						this.isScrolling = setTimeout(() => {
							this.preventReveal = false;
						}, 66);

						requestAnimationFrame(this.hide.bind(this));
					}
				}
				else if (scrollTop <= this.headerBounds.top) {
					requestAnimationFrame(this.reset.bind(this));
				}
			}
			else {
				if (scrollTop > this.headerBounds.bottom) {
					if (this.sticky()) return;
					
					requestAnimationFrame(this.hide.bind(this));

					setTimeout(() => {
						requestAnimationFrame(this.reveal.bind(this));
					}, 100);
				}
				else if (scrollTop <= this.headerBounds.top) {
					requestAnimationFrame(this.reset.bind(this));
				}
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		}

		reveal() {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}

		reset() {
			this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		}

		sticky() {
			return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
		}
	}
	customElements.define('sticky-header', StickyHeader);

	const headerSelectCountry = document.querySelector('#custom-select-country');
	if (headerSelectCountry) {
		const customSelectCountryPopup = headerSelectCountry.querySelector('.custom-select-country_popup');
		headerSelectCountry.querySelector(".global-icon").addEventListener("click", () => {
			document.body.style.overflow = 'hidden';
			customSelectCountryPopup.classList.add('open');
		})

		headerSelectCountry.querySelector('.close-icon').addEventListener('click', () => {
			customSelectCountryPopup.classList.remove('open');
			document.body.style.overflow = 'auto';
		})

		headerSelectCountry.querySelector('.close-custom-select-country').addEventListener('click', () => {
			customSelectCountryPopup.classList.remove('open');
			document.body.style.overflow = 'auto';
		})
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["process-scroll-media"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('process-scroll-media')) {
  customElements.define('process-scroll-media', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.addEventListener('click', event => {
        const tab = event.target.closest('[role="tab"]');
        const index = this.tabs.indexOf(tab);
        if (index >= 0) this.select(index);
      }, options);
      this.addEventListener('keydown', event => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.select(next);
        this.tabs[next].focus();
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.select(index);
      }, options);
    }
    select(index) {
      this.tabs.forEach((tab, position) => {
        const active = position === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        this.panels[position].hidden = !active;
        this.panels[position].inert = !active;
      });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stat-media-tabs"] && !Shopify.designMode) return;
  try {
    
/* Shared tabs for the statistic card and step/image sections. */
if (!customElements.get('tabbed-media')) {
  customElements.define('tabbed-media', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.index = Math.max(0, this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true'));
      this.addEventListener('click', event => {
        const tab = event.target.closest('[role="tab"]');
        if (tab) this.select(this.tabs.indexOf(tab));
        const arrow = event.target.closest('[data-tab-direction]');
        if (arrow) this.select(this.index + Number(arrow.dataset.tabDirection));
      }, options);
      this.addEventListener('keydown', event => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = index + 1;
        if (event.key === 'ArrowLeft') next = index - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.select(next);
        this.tabs[this.index].focus();
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.select(index);
      }, options);
    }
    select(index) {
      if (!this.tabs.length) return;
      this.index = (index + this.tabs.length) % this.tabs.length;
      this.tabs.forEach((tab, position) => {
        const active = position === this.index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        this.panels[position].hidden = !active;
      });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["steps-image-tabs"] && !Shopify.designMode) return;
  try {
    
/* Shared tabs for the statistic card and step/image sections. */
if (!customElements.get('tabbed-media')) {
  customElements.define('tabbed-media', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.index = Math.max(0, this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true'));
      this.addEventListener('click', event => {
        const tab = event.target.closest('[role="tab"]');
        if (tab) this.select(this.tabs.indexOf(tab));
        const arrow = event.target.closest('[data-tab-direction]');
        if (arrow) this.select(this.index + Number(arrow.dataset.tabDirection));
      }, options);
      this.addEventListener('keydown', event => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = index + 1;
        if (event.key === 'ArrowLeft') next = index - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.select(next);
        this.tabs[this.index].focus();
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.select(index);
      }, options);
    }
    select(index) {
      if (!this.tabs.length) return;
      this.index = (index + this.tabs.length) % this.tabs.length;
      this.tabs.forEach((tab, position) => {
        const active = position === this.index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        this.panels[position].hidden = !active;
      });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-image-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('text-image-slider-tabs')) {
    customElements.define('text-image-slider-tabs', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.addEventListener('click', (event) => {
          const index = this.tabs.indexOf(event.target.closest('[role="tab"]'));
          if (index >= 0) this.activate(index);
        }, options);
        this.addEventListener('keydown', (event) => {
          const index = this.tabs.indexOf(event.target);
          if (index < 0) return;
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.activate(next);
          this.tabs[next].focus();
        }, options);
        this.closest('.shopify-section').addEventListener('shopify:block:select', (event) => {
          const tabIndex = this.tabs.findIndex((tab) => tab.dataset.tabBlockId === event.detail.blockId);
          const panelIndex = this.panels.findIndex((panel) => panel.contains(event.target));
          const index = tabIndex >= 0 ? tabIndex : panelIndex;
          if (index < 0) return;
          this.activate(index);
          const slide = event.target.closest('.swiper-slide');
          const gallery = slide?.closest('default-swiper');
          if (gallery?.swiper) {
            gallery.swiper.slideTo(Array.from(gallery.querySelectorAll('.swiper-slide')).indexOf(slide), 0);
          }
        }, options);
      }

      activate(index) {
        this.tabs.forEach((tab, position) => {
          const selected = position === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[position].hidden = !selected;
        });
        // Hidden galleries need their dimensions refreshed after becoming visible.
        this.panels[index].querySelector('default-swiper')?.swiper?.update();
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
